module.exports = __webpack_public_path__ + "static/images/medical.3D1tBvn.svg";